// Enhanced product card functionality for Shopify
let observer = null;
let isInitialized = false;

// Single initialization - wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeEnhancements);
} else {
  // DOM already loaded
  initializeEnhancements();
}

function initializeEnhancements() {
  // Prevent double initialization
  if (isInitialized) {
    console.log('Already initialized, skipping...');
    return;
  }
  
  console.log('=== INITIALIZING PRODUCT CARD ENHANCEMENTS ===');
  isInitialized = true;
  
  try {
    // Add custom styles to DOM
    addCustomStyles();
    
    // Initialize everything
    enhanceProductCards();
    
    // IMAGE ZOOM DISABLED - causes mobile crashes with 250+ products
    // if (!isMobile) {
    //   initializeImageZoom();
    // }
    
    // Set up mutation observer for dynamically loaded content (AJAX pagination, etc.)
    setupMutationObserver();
    
    console.log('=== PRODUCT CARD ENHANCEMENTS COMPLETE ===');
  } catch (error) {
    console.error('Error during initialization:', error);
  }
}

function setupMutationObserver() {
  if (observer) {
    observer.disconnect();
  }
  
  observer = new MutationObserver((mutations) => {
    let hasNewCards = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          if (node.classList.contains('product-card-wrapper') || 
              node.querySelector('.product-card-wrapper')) {
            hasNewCards = true;
          }
        }
      });
    });
    
    if (hasNewCards) {
      console.log('New product cards detected, re-initializing...');
      enhanceProductCards();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function addCustomStyles() {
  // Check if styles already added
  if (document.getElementById('product-card-custom-styles')) {
    return;
  }
  
  const style = document.createElement('style');
  style.id = 'product-card-custom-styles';
  style.textContent = `
    /* Remove card link overlays to fix click issues */
    .card__heading a::after {
      display: none !important;
    }
    
    /* Make product images clickable */
    .card__media {
      cursor: pointer;
    }
    
    /* Modern add to cart button - simple black + in corner */
    .modern-add-btn {
      position: absolute;
      bottom: 8px;
      right: 8px;
      width: auto;
      height: auto;
      background: none;
      color: #000;
      border: none;
      border-radius: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 300;
      cursor: pointer;
      opacity: 0;
      transform: translateY(5px);
      transition: all 0.3s ease;
      z-index: 10;
      padding: 4px;
    }
    
    .product-card-wrapper:hover .modern-add-btn {
      opacity: 1;
      transform: translateY(0);
    }
    
    .modern-add-btn:hover {
      color: #333;
      transform: scale(1.1);
    }
    
    .modern-add-btn.loading {
      color: #666;
      cursor: not-allowed;
    }
    
    .modern-add-btn.success {
      color: #28a745;
    }
    
    .modern-add-btn.success.spin-once {
      animation: spin-once 0.6s ease-out forwards;
    }
    
    @keyframes spin-once {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    .modern-add-btn.error {
      color: #dc3545;
    }
    
    /* Modern size selector - only shows when clicked */
    .modern-size-popup {
      position: absolute;
      bottom: 35px;
      left: 8px;
      right: 8px;
      background: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(10px);
      padding: 12px;
      border-radius: 6px;
      opacity: 0;
      visibility: hidden;
      transform: translateY(20px);
      transition: all 0.3s ease;
      z-index: 15;
      border: 1px solid #eee;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }
    
    .modern-size-popup.show {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
    
    .size-title {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      margin-bottom: 8px;
      color: #333;
      letter-spacing: 0.5px;
    }
    
    .modern-sizes {
      display: flex;
      gap: 6px;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
      padding: 2px 0;
    }
    
    .modern-sizes::-webkit-scrollbar {
      display: none;
    }
    
    .modern-size {
      padding: 8px 12px;
      border: 1px solid #ddd;
      background: #fff;
      font-size: 11px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      flex-shrink: 0;
      white-space: nowrap;
    }
    
    .modern-size:hover:not(:disabled) {
      border-color: #000;
      background: #000;
      color: #fff;
    }
    
    .modern-size.selected {
      background: #000;
      color: #fff;
      border-color: #000;
    }
    
    .modern-size:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      text-decoration: line-through;
    }
    
    /* Close button for size popup */
    .size-popup-close {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 20px;
      height: 20px;
      background: none;
      border: none;
      font-size: 16px;
      cursor: pointer;
      color: #999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .size-popup-close:hover {
      color: #000;
    }
    
    /* Hide original size selector */
    .product-card-size-selector {
      display: none !important;
    }
    
    @media (max-width: 768px) {
      .modern-size-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 16px 16px 0 0;
        padding: 20px;
        transform: translateY(100%);
        z-index: 1000;
      }
      
      .modern-size-popup.show {
        transform: translateY(0);
      }
      
      .modern-add-btn {
        opacity: 1;
        transform: none;
      }
      
      .size-title {
        font-size: 14px;
        margin-bottom: 12px;
        text-align: center;
      }
      
      .modern-size {
        padding: 12px 16px;
        font-size: 12px;
        min-width: 44px;
        text-align: center;
      }
    }
  `;
  document.head.appendChild(style);
}

// IMAGE ZOOM FUNCTION REMOVED - was causing mobile crashes with 250+ products
// Can be re-enabled for desktop-only stores or smaller collections

function enhanceProductCards() {
  const productCards = document.querySelectorAll('.product-card-wrapper');
  
  productCards.forEach(card => {
    // Skip if already enhanced
    if (card.dataset.enhanced) {
      return;
    }
    card.dataset.enhanced = 'true';
    
    // Make images clickable
    setupImageNavigation(card);
    
    // Add modern size selector if product has variants
    const originalSizeSelector = card.querySelector('.product-card-size-selector');
    if (originalSizeSelector) {
      addModernSizeSelector(card, originalSizeSelector);
    }
    
    // Add modern add to cart button
    addModernAddButton(card);
  });
}

function setupImageNavigation(card) {
  const productLink = card.querySelector('.card__heading a');
  const productImage = card.querySelector('.card__media');
  
  if (productLink && productImage) {
    productImage.addEventListener('click', (e) => {
      // Don't navigate if clicking on our custom elements
      if (e.target.closest('.modern-add-btn') || e.target.closest('.modern-size-popup')) {
        return;
      }
      window.location.href = productLink.href;
    });
  }
}

function addModernSizeSelector(card, originalSelector) {
  const sizeButtons = originalSelector.querySelectorAll('.size-option');
  if (sizeButtons.length === 0) return;
  
  const popup = document.createElement('div');
  popup.className = 'modern-size-popup';
  
  const closeBtn = document.createElement('button');
  closeBtn.className = 'size-popup-close';
  closeBtn.innerHTML = '×';
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    hidePopup(popup);
  });
  
  const title = document.createElement('div');
  title.className = 'size-title';
  title.textContent = 'Select Size';
  
  const sizesContainer = document.createElement('div');
  sizesContainer.className = 'modern-sizes';
  
  sizeButtons.forEach(btn => {
    const modernSize = document.createElement('button');
    modernSize.className = 'modern-size';
    modernSize.textContent = btn.textContent.trim();
    modernSize.disabled = btn.disabled;
    modernSize.dataset.size = btn.dataset.size;
    modernSize.dataset.productId = btn.dataset.productId;
    
    modernSize.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Remove selected from all
      sizesContainer.querySelectorAll('.modern-size').forEach(s => s.classList.remove('selected'));
      // Add selected to clicked
      modernSize.classList.add('selected');
      
      // Store selection
      card.dataset.selectedSize = modernSize.dataset.size;
      
      // Hide popup after selection and immediately add to cart
      hidePopup(popup);
      
      // Find the add button and trigger add to cart
      const addButton = card.querySelector('.modern-add-btn');
      if (addButton) {
        setTimeout(() => {
          handleAddToCart(addButton, card);
        }, 100);
      }
    });
    
    sizesContainer.appendChild(modernSize);
  });
  
  popup.appendChild(closeBtn);
  popup.appendChild(title);
  popup.appendChild(sizesContainer);
  
  // Add to card media area
  const mediaArea = card.querySelector('.card__media');
  if (mediaArea) {
    mediaArea.style.position = 'relative';
    mediaArea.appendChild(popup);
  }
  
  // Store popup reference on card for easy access
  card.sizePopup = popup;
}

function addModernAddButton(card) {
  const button = document.createElement('button');
  button.className = 'modern-add-btn';
  button.innerHTML = '+';
  button.title = 'Add to Cart';
  
  button.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Check if product has variants/sizes and none selected
    const sizePopup = card.sizePopup;
    if (sizePopup && !card.dataset.selectedSize) {
      // Show size selector
      showPopup(sizePopup);
    } else {
      // Add to cart directly
      handleAddToCart(button, card);
    }
  });
  
  // Add to card media area
  const mediaArea = card.querySelector('.card__media');
  if (mediaArea) {
    mediaArea.style.position = 'relative';
    mediaArea.appendChild(button);
  }
}

function showPopup(popup) {
  // Close any other open popups first
  document.querySelectorAll('.modern-size-popup.show').forEach(p => {
    if (p !== popup) hidePopup(p);
  });
  
  popup.classList.add('show');
  
  // Add click outside to close
  setTimeout(() => {
    document.addEventListener('click', function closeOnOutside(e) {
      if (!popup.contains(e.target)) {
        hidePopup(popup);
        document.removeEventListener('click', closeOnOutside);
      }
    });
  }, 100);
}

function hidePopup(popup) {
  popup.classList.remove('show');
}

function handleAddToCart(button, card) {
  const selectedSize = card.dataset.selectedSize;
  const productLink = card.querySelector('.card__heading a');
  
  if (!productLink) return;
  
  const productUrl = productLink.href;
  const productHandle = productUrl.split('/').pop().split('?')[0];
  
  // Show loading
  button.classList.add('loading');
  button.innerHTML = '...';
  button.disabled = true;
  
  console.log('=== ADD TO CART DEBUG ===');
  console.log('Product handle:', productHandle);
  console.log('Selected size:', selectedSize);
  
  // Add to cart
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      console.log('Product data:', product);
      console.log('Available variants:', product.variants);
      
      let selectedVariant = product.variants[0]; // Default to first variant
      const hasVariants = product.variants.length > 1;
      
      // If size was selected, find matching variant
      if (selectedSize && hasVariants) {
        console.log('Looking for variant with size:', selectedSize);
        
        const matchingVariant = product.variants.find(variant => {
          const matches = 
            variant.title.toLowerCase().includes(selectedSize.toLowerCase()) ||
            (variant.option1 && variant.option1.toLowerCase() === selectedSize.toLowerCase()) ||
            (variant.option2 && variant.option2.toLowerCase() === selectedSize.toLowerCase()) ||
            (variant.option3 && variant.option3.toLowerCase() === selectedSize.toLowerCase()) ||
            variant.options.some(option => option.toLowerCase() === selectedSize.toLowerCase());
          
          console.log(`Checking variant "${variant.title}":`, {
            options: variant.options,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            matches: matches
          });
          
          return matches;
        });
        
        if (matchingVariant) {
          selectedVariant = matchingVariant;
          console.log('Found matching variant:', selectedVariant);
        } else {
          console.log('No matching variant found, using first variant:', selectedVariant);
        }
      }
      
      console.log('Adding variant to cart:', {
        id: selectedVariant.id,
        title: selectedVariant.title,
        available: selectedVariant.available,
        hasVariants: hasVariants
      });
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: selectedVariant.id, 
          quantity: 1 
        })
      }).then(response => {
        return { response, hasVariants };
      });
    })
    .then(({ response, hasVariants }) => {
      console.log('Cart add response status:', response.status);
      if (response.ok) {
        return response.json().then(cartData => ({ cartData, hasVariants }));
      } else {
        return response.text().then(text => {
          console.error('Cart add error response:', text);
          throw new Error(`Add to cart failed: ${response.status}`);
        });
      }
    })
    .then(({ cartData, hasVariants }) => {
      console.log('Successfully added to cart:', cartData, 'Has variants:', hasVariants);
      
      button.classList.remove('loading');
      
      // Show spinning animation for all products when added to cart
      button.classList.add('success', 'spin-once');
      button.innerHTML = '+'; // Keep the plus sign
      
      // Update cart properly using theme's system
      updateCartCountProper(cartData);
      
      setTimeout(() => resetButton(button), 1000);
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      button.classList.remove('loading');
      button.classList.add('error');
      button.innerHTML = '✗';
      setTimeout(() => resetButton(button), 2000);
    });
}

function resetButton(button) {
  button.classList.remove('loading', 'success', 'error', 'spin-once');
  button.innerHTML = '+';
  button.disabled = false;
}

function updateCartCountProper(cartData) {
  // Use the theme's pubsub system for proper cart updates
  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    console.log('Publishing cart update through theme system');
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-card',
      cartData: cartData,
      productVariantId: cartData.variant_id
    });
  }
  
  // Also refresh the cart icon bubble via AJAX
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Updated cart data:', cart);
      
      // Update the cart icon bubble by fetching the updated section
      return fetch(`${window.location.origin}/?section_id=cart-icon-bubble`);
    })
    .then(response => response.text())
    .then(html => {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.innerHTML = html;
        console.log('Cart icon updated successfully');
      }
      
      // Also try to trigger theme's cart refresh events
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(error => {
      console.error('Cart count update error:', error);
      
      // Fallback: Simple counter update
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Update any cart count elements
          const cartCountElements = document.querySelectorAll('[aria-hidden="true"]');
          cartCountElements.forEach(el => {
            if (el.parentElement && el.parentElement.classList.contains('cart-count-bubble')) {
              el.textContent = cart.item_count;
            }
          });
          
          // Show/hide cart count bubble
          const cartBubbles = document.querySelectorAll('.cart-count-bubble');
          cartBubbles.forEach(bubble => {
            if (cart.item_count > 0) {
              bubble.style.display = 'block';
            } else {
              bubble.style.display = 'none';
            }
          });
        });
    });
}